import React from 'react';

import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';

import buildStatusTableContents from './buildStatusTableContents';
import StatusTableTitle from './StatusTableTitle';
import StatusTableActions from './StatusTableActions';

export default function useStatusTable() {
  const {
    pipeline: { writekey, lastDeployed, cluster },
  } = usePipelinePageContext();

  return {
    numberOfColumns: 2,
    data: buildStatusTableContents({ lastDeployed, cluster }),
    title: <StatusTableTitle writekey={writekey} />,
    actions: <StatusTableActions />,
  };
}
